import { Box, Button,  FormControl,  FormHelperText,  Grid, InputLabel, makeStyles, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import React, { useState } from "react";
import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import validateDateAndFormat from "utils/validateDateAndFormat";
import { getPaymentReportCaseNumberWise } from "features/Tdsat/API/TdsatApi";
import CaseTypeInput from "features/Tdsat/components/CaseTypeInput";
import { TDSAT_DROPDOWN_DATES } from "app/constants";

const useStyles = makeStyles((theme)=>({
  filtersContainer: {
    padding: '1rem', 
    borderBottom: '1px solid black', 
    display: 'flex', 
    gap: '15px', 
    justifyContent:'center',
    // width: '80%',
    margin: 'auto',
  },
  buttonPrint: {
    borderRadius: '0.5rem',
    border: '1px solid #AAAFB9',
    background: '#fff',
    padding: '0.5rem 1rem',
  },
  tableHeadItem:{
		// color: 'grey',
		fontFamily: 'Satoshi-Bold',
    wordBreak: 'break-word',
	},
	tableRowValue: {
		// color: '#858D98',
		fontSize: '0.9375rem',
    wordBreak: 'break-word',
    whiteSpace: 'pre-line',
	},
	valuePaper: {
		padding: "1.5rem 8px",
		cursor: "pointer",
		boxShadow: "none",
		width: "100%",
		border: "1px solid #E0E0E0",
		"&:hover": {
			background: "#E5F6EF",
			'& $downloadButton': {
				visibility: 'visible',
			}
		},
		[theme.breakpoints.down("sm")]: {
			textAlign: "center",
		},
	},
}))

export default function PaymentReportCaseNumberWise() {
  const classes = useStyles();

  const [formData, setFormData] = useState({
    case_type: '',
    case_number: '',
    year: '',
  }) ;
  const [loading, setLoading] = useState(false);
  const [cases, setCases] = useState([]);
  const [errors,setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const spacing = [2,2,2,2,2,2];
  const tableHeadings = ['Sr. No.','Case No.','Account Sr. No.','Recieved From','Amount (INR)','Date'];

  const processResponse = (data,index) => {
    const item = data;
    const arr = [
      index+1, 
      item?.case_number,  
			item?.receipt_number,
      item?.created_by_name,
      item?.amount || '-',
      validateDateAndFormat(item?.created_at,"dd/MM/y"),
    ];
    return arr;
  }

  const reload = (case_number, case_type, year) => {
		setLoading(true);
		getPaymentReportCaseNumberWise(case_number, case_type, year)
    .then((res)=>{
      const response = res?.data?.error ? [] : res?.data || [];
      setCases(response);
      // const processedResponse = processResponse(response);
      // let count = res?.data?.count;
      // let t = parseInt(count / PAGE_SIZE);
      // let r = count % PAGE_SIZE;
      // let total = t + (r > 0 ? 1 : 0);
      // setTotalPages(total);
      setLoading(false);
    })
    .catch((error)=>{
      console.log('Error: ',error);
      setLoading(false)
    })
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleClickSubmit = () => {
    let hasError = false;
    let newErrors = { case_number: '', year: '', case_type: '' };
    if (!formData.case_number) {
        newErrors.case_number = 'Case Number is required';
        hasError = true;
    }
    if (!formData.year || formData.year === 'Select') {
        newErrors.year = 'Year is required';
        hasError = true;
    }
    if (!formData.case_type) {
        newErrors.case_type = 'Case Type is required';
        hasError = true;
    }

    setErrors(newErrors);
    if(!hasError){
      setSubmitted(true);
      reload(formData?.case_number, formData?.case_type, formData?.year);
    }
  }

  return (
    <Box>
      <Typography style={{fontSize:'1.5rem', padding:'2rem'}}>
        PAYMENT REPORT CASE NUMBER WISE
      </Typography>
      <Box style={{backgroundColor:'white'}}>
        <Box style={{height:'1rem'}}></Box>
        <Box className={classes.filtersContainer} style={{justifyContent:'space-between'}}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <CaseTypeInput
                size="small"
                name="case_type"
                isRequired={true}
                caseType={formData?.case_type}
                onChange={handleInputChange}
                label="Case Type"
                error={errors?.case_type}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                size="small"
                label={'Case Number'}
                name="case_number"
                fullWidth
                required
                margin="none"
                variant="outlined"
                value={formData?.case_number}
                onChange={handleInputChange}
                error={!!errors.case_number}
                helperText={errors.case_number}
              />
            </Grid>
            <Grid item xs={3}>
              <FormControl required fullWidth margin="none" variant="outlined" size="small">
              <InputLabel>{'Year'}</InputLabel>
              <Select
                label={'Year'}
                name="year"
                value={formData.year}
                onChange={handleInputChange}
              >
                {TDSAT_DROPDOWN_DATES.map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
                ))}
              </Select>
              {errors.year && <FormHelperText error>{errors.year}</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <Button
                className={classes.buttonPrint}
                size="small"
                onClick={handleClickSubmit}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Box>
        {submitted && (
          <Box>
            <Box style={{height: '2rem'}}/>
            <Grid container style={{ rowGap: "8px" }}>
              <Box style={{padding:'1.5rem 8px', width: '100%'}}>
                <Grid container spacing={1} justifyContent="flex-start">
                  {tableHeadings.map((heading,index)=>{
                    return (
                      <Grid key={index} item xs sm={spacing[index]}>
                        <Typography className={classes.tableHeadItem}>
                          {heading}
                        </Typography>
                      </Grid>
                    )
                  })}
                </Grid>
              </Box>
              {loading ? (
                <Box style={{margin:'auto',width:'100%',padding:'2rem 0'}}>
                  <CircularCenteredLoader/>
                </Box>
              ) : (
                cases.length !== 0 ? (
                  cases.map((dispute,index) => {
                    const processedDispute = processResponse(dispute,index);
                    return (
                      <Box key={index} className={classes.valuePaper}>
                        <Grid container spacing={1} justifyContent="flex-start">
                          {processedDispute.map((item,index)=>{
                            return (
                              <Grid key={index} item xs sm={spacing[index]}>
                                <Typography className={classes.tableRowValue}>
                                  {item}
                                </Typography>
                              </Grid>
                            )
                          })}
                        </Grid>
                      </Box>
                    );
                  })
                ) : (
                  <Grid container justify="center">
                    <Grid item>
                      <Box textAlign="center">
                        <Typography
                          style={{
                            padding: '2rem 8px',
                            textAlign: 'center',
                            fontSize: '1.5rem'
                          }}
                        >
                          No payment report is found for this criteria.
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                )
              )}
              {/* {cases.length !== 0 && (
                <Box style={{padding:'16px'}}>
                  <Pagination color="primary" count={totalPages} page={page} onChange={handlePageChange}/>
                </Box>
              )} */}
            </Grid>
            <Box style={{height: '2rem'}}/>
            {(cases.length !== 0) && (
              <Box style={{display:'flex',width:'15rem',margin:'auto',gap:'1rem',paddingBottom:'1.5rem'}}>
                <Typography style={{width:'50%'}}>Total Amount</Typography>
                <Typography style={{width:'50%'}}>{cases.reduce((total, item) => total + item?.amount, 0) || '--'}</Typography>
              </Box>
            )}
          </Box>
        )}
      </Box>
    </Box>
  )
}